import { useMutation } from '@tanstack/react-query';

import { CompletedMatch } from '@/modules/league/new-components/types';

async function saveCompletedMatchScores({
  match,
  mutationData,
}: {
  match: CompletedMatch;
  mutationData: {
    [key: string]: number;
  };
}) {
  try {
    const response = await fetch(`/api/v1/leagues/gameDay/header/saveCompletedMatchScores`, {
      method: 'POST',
      body: JSON.stringify({
        ...mutationData,
        ScoreID: match.ScoreID,
      }),
    });
    const responseData = await response.json();
    return responseData.data;
  } catch {
    /* empty */
  }
}

export const useSaveCompletedMatchScores = () => useMutation(saveCompletedMatchScores);
